"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NotRepresentableException = _interopRequireDefault(require("./NotRepresentableException"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Double = _interopRequireDefault(require("../../../../java/lang/Double"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HCoordinate =
/*#__PURE__*/
function () {
  function HCoordinate() {
    _classCallCheck(this, HCoordinate);

    HCoordinate.constructor_.apply(this, arguments);
  }

  _createClass(HCoordinate, [{
    key: "getY",
    value: function getY() {
      var a = this.y / this.w;

      if (_Double.default.isNaN(a) || _Double.default.isInfinite(a)) {
        throw new _NotRepresentableException.default();
      }

      return a;
    }
  }, {
    key: "getX",
    value: function getX() {
      var a = this.x / this.w;

      if (_Double.default.isNaN(a) || _Double.default.isInfinite(a)) {
        throw new _NotRepresentableException.default();
      }

      return a;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var p = new _Coordinate.default();
      p.x = this.getX();
      p.y = this.getY();
      return p;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return HCoordinate;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var px = p1.y - p2.y;
      var py = p2.x - p1.x;
      var pw = p1.x * p2.y - p2.x * p1.y;
      var qx = q1.y - q2.y;
      var qy = q2.x - q1.x;
      var qw = q1.x * q2.y - q2.x * q1.y;
      var x = py * qw - qy * pw;
      var y = qx * pw - px * qw;
      var w = px * qy - qx * py;
      var xInt = x / w;
      var yInt = y / w;

      if (_Double.default.isNaN(xInt) || _Double.default.isInfinite(xInt) || _Double.default.isNaN(yInt) || _Double.default.isInfinite(yInt)) {
        throw new _NotRepresentableException.default();
      }

      return new _Coordinate.default(xInt, yInt);
    }
  }]);

  return HCoordinate;
}();

exports.default = HCoordinate;

HCoordinate.constructor_ = function () {
  this.x = null;
  this.y = null;
  this.w = null;

  if (arguments.length === 0) {
    this.x = 0.0;
    this.y = 0.0;
    this.w = 1.0;
  } else if (arguments.length === 1) {
    var p = arguments[0];
    this.x = p.x;
    this.y = p.y;
    this.w = 1.0;
  } else if (arguments.length === 2) {
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
      var _x = arguments[0],
          _y = arguments[1];
      this.x = _x;
      this.y = _y;
      this.w = 1.0;
    } else if (arguments[0] instanceof HCoordinate && arguments[1] instanceof HCoordinate) {
      var p1 = arguments[0],
          p2 = arguments[1];
      this.x = p1.y * p2.w - p2.y * p1.w;
      this.y = p2.x * p1.w - p1.x * p2.w;
      this.w = p1.x * p2.y - p2.x * p1.y;
    } else if (arguments[0] instanceof _Coordinate.default && arguments[1] instanceof _Coordinate.default) {
      var _p = arguments[0],
          _p2 = arguments[1];
      this.x = _p.y - _p2.y;
      this.y = _p2.x - _p.x;
      this.w = _p.x * _p2.y - _p2.x * _p.y;
    }
  } else if (arguments.length === 3) {
    var _x2 = arguments[0],
        _y2 = arguments[1],
        _w = arguments[2];
    this.x = _x2;
    this.y = _y2;
    this.w = _w;
  } else if (arguments.length === 4) {
    var _p3 = arguments[0],
        _p4 = arguments[1],
        q1 = arguments[2],
        q2 = arguments[3];
    var px = _p3.y - _p4.y;
    var py = _p4.x - _p3.x;
    var pw = _p3.x * _p4.y - _p4.x * _p3.y;
    var qx = q1.y - q2.y;
    var qy = q2.x - q1.x;
    var qw = q1.x * q2.y - q2.x * q1.y;
    this.x = py * qw - qy * pw;
    this.y = qx * pw - px * qw;
    this.w = px * qy - qx * py;
  }
};